import React from 'react';
import noop from 'lodash/noop';
import classNames from 'classnames';
import Button from '../button';
import { Size } from '../_util/enum';
const Operation = function Operation(props) {
    const { moveToLeft = noop, moveToRight = noop, leftArrowText = '', rightArrowText = '', leftActive, rightActive, className, style, buttonProps, } = props;
    const customLeftClass = classNames(`${className}-custom-left-active`, {
        [`${className}-custom-left-disable`]: !leftActive,
    });
    const customRightClass = classNames(`${className}-custom-left-active`, {
        [`${className}-custom-left-disable`]: !rightActive,
    });
    return (React.createElement("div", { className: className, style: style },
        typeof leftArrowText === 'string' ? (React.createElement(Button, Object.assign({}, buttonProps, { type: "primary", size: Size.small, disabled: !leftActive, onClick: moveToLeft, icon: "keyboard_arrow_left" }), leftArrowText)) : (React.createElement("div", { className: customLeftClass, onClick: leftActive ? moveToLeft : undefined }, leftArrowText)),
        typeof rightArrowText === 'string' ? (React.createElement(Button, Object.assign({}, buttonProps, { type: "primary", size: Size.small, disabled: !rightActive, onClick: moveToRight, icon: "keyboard_arrow_right" }), rightArrowText)) : (React.createElement("div", { className: customRightClass, onClick: rightActive ? moveToRight : undefined }, rightArrowText))));
};
Operation.displayName = 'TransferOperation';
export default Operation;
